/**
 * @module checkout 
 *  Apis must need auth details to trigger url - NormalApi
 */
import Env from '@/env';
import store from '@/store/store';
import NormalApi from '@/Components/Controllers/NormalApis';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import Helpers from '@/Components/Helpers/Helpers';

export default {

    /**
     * Fetch data id id
     */
    checkout({ cartId, receive_time, pay_later, order_receive_method, tip, token, delivery, delivery_fee, note, user = null, payment_info = null , billingDetails = null }) {
        // Send user activy emit, user , location details verified within the function
        Helpers.emitUserActivity();
        let in_store = store.getters['getInStore'];
        const url = `${Env.cartUrl}/api/v1/cart/${cartId}/processCart`;

        let orderReceivedMethod = 'pickup'; // by default
        if(order_receive_method == 'pickup' && in_store){
          orderReceivedMethod = 'instore';
        } else if (order_receive_method == 'delivery') {
          orderReceivedMethod = 'delivery';
        }

        let selectedLocation = store.getters['location/selected'];
        let obj = {
          receive_time,
          pay_later,
          token,
          order_receive_method: orderReceivedMethod,
          tip,
          note,
          in_store: in_store ? true : false,
          delivery: order_receive_method == 'delivery' ? delivery : null,
          delivery_fee: order_receive_method == 'delivery' ? parseFloat(delivery_fee) : null,
          platform: Env.appPlatform,
          payment_processor: selectedLocation.settings && selectedLocation.settings.payment_processor_details ? selectedLocation.settings.payment_processor_details.provider_name : null,
      };
  
      // we will get user only if user is not logged in
      if(user !== null){
        obj.user = user;
      }
      if(billingDetails !== null){
        obj.billingDetails = billingDetails;
      }
      if(payment_info !== null){
        obj.payment_info = payment_info;
      }
      return NormalApi.postApi(url, {}, obj)
          .then(async (res) => {
            let orderId = res.data.payload.order_id;
            // now get all the order data from order service
            let orderDetail = await OrderHistoryApis.fetchOrderById(orderId)
            return orderDetail
          })
          .catch(err => err);
    },

}